import React from 'react';

export const RebalanceSearchResultsContainer = (): JSX.Element => {
  return <div>TODO Rebalance Search Results</div>;
};
